import messages from './messages.tsx';

export const successFlagConfig = {
	type: 'success',
	title: messages.feedbackSuccessFlagTitle,
	description: messages.feedbackSuccessFlagDescription,
	isAutoDismiss: true,
	messageId: 'feedback-collector.ui.feedback-renderer.success-flag',
	messageType: 'transactional',
} as const;
